/* eslint-disable camelcase */
/* eslint-disable no-magic-numbers */

const url = new URL(window.location.href);
const pathSegments = url.pathname.split("/");
const formName = decodeURI(pathSegments[pathSegments.length - 1]);

const formObserver = new MutationObserver((mutationsList) => {
  mutationsList.some((mutation) => {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      const addedNode = mutation.addedNodes[0];
      if (addedNode?.id === "app-embed" && addedNode.tagName.toLowerCase() === "form-embed") {
        observeInitForm(addedNode);
        return; // stop further iteration
      }
    }
    return;
  });
});
formObserver.observe(document.body, { childList: true, subtree: true });

function observeInitForm(form) {
  const formContentContainer = form.shadowRoot.querySelector("div");
  const formData = formContentContainer.querySelector("form");
  const phoneNumberFiled = formData.querySelector(
    "._formPhoneInputContainer_1ym3p_6"
  );
  if (phoneNumberFiled) {
    phoneNumberFiled.style.direction = "ltr";
  }
  const labels = formData.querySelectorAll("label");
  changeLabelToRtl(labels);
}

function changeLabelToRtl(labels) {
  labels.forEach((label) => {
    label.style.right = "15px";
    label.style.left = "unset";
    label.style.transformOrigin = "right";
  });
}
